import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'
import type { SettlementCostItem } from '../types'

/** Carries the named annual items over, so a missing one stays visible. */
export function useCopyCostItems() {
  return useSettlementMutation<
    { id: string; source?: string },
    SettlementCostItem[]
  >({
    toastKey: 'settlementCostItemsCopied',
    request: async ({ id, source }) =>
      (
        await apiClient.post<SettlementCostItem[]>(
          `${settlementsUrl}/${id}/copy-cost-items`,
          { source }
        )
      ).data
  })
}
